export const api_key = "https://uatapi.japa.health/api/v1/";
export const sns_api_key = "https://uatapi.japa.health/api/v1/";
